import styled from 'styled-components';

export const CheckboxLife = styled.div`
  position: relative;
  display: flex;

  input[type='checkbox'] {
    display: none;
  }

  & label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  & p {
    margin-left: 21px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #0000008f;
    cursor: pointer;
  }

  input + label {
    &:before {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      box-sizing: border-box;
      border-radius: 5px;
      border: 4px solid #0000008f;
      background-color: transparent;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      color: red;
    }
  }

  input:checked + label {
    &:before {
      border-color: #ff0073;
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 10 10'%3E%3Cg stroke-width='1' fill='currentColor'%3E%3Cpath fill='none' stroke='%23FF0073' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' data-cap='butt' d='M2.83 4.72l1.58 1.58 2.83-2.83'/%3E%3C/g%3E%3C/svg%3E");
      background-position: center;
      background-color: transparent;
      cursor: pointer;
    }
  }
`;
